import {createSlice, Dispatch, PayloadAction} from '@reduxjs/toolkit';

interface LoadingSetup {
  message?: string;
  amount?: number;
}

interface UserState {
  isLoading: boolean;
  loadingText: string | undefined;
  loadingAmount: number | undefined;
  redirectSearchSuggestion: string | null;
}

const initialState: UserState = {
  isLoading: false,
  loadingText: '',
  loadingAmount: 0,
  redirectSearchSuggestion: null
}

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setLoadingVisible(state, action: PayloadAction<boolean>): void {
      state.isLoading = action.payload;
    },
    setLoading(state, action: PayloadAction<LoadingSetup>): void {
      state.loadingText = action.payload.message;
      state.loadingAmount = action.payload.amount;
    },
    setUrlSuggestion(state, action: PayloadAction<string|null>): void {
      state.redirectSearchSuggestion = action.payload
    }
  }
});

export const {
  setLoadingVisible,
  setLoading,
  setUrlSuggestion
} = appSlice.actions;

// Define a thunk that dispatches those action creators
export const showLoading = () => (dispatch: Dispatch) => {
  dispatch(setLoadingVisible(true));
}

export const hideLoading = () => (dispatch: Dispatch) => {
  dispatch(setLoadingVisible(false));
}

export const redirectUrlSuggestion = (url: any) => (dispatch: Dispatch) => {dispatch(setUrlSuggestion(url))}
export default appSlice.reducer;
